import React from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { withRouter } from 'helpers/ModuleHelper';
import MediaBox from 'components/MediaBox/MediaBox';
import { connect } from 'react-redux';
import * as actions from 'store/actions';
import { sliceText, getDuration } from 'helpers/FieldHelper';
import { isAudio } from 'helpers/AppHelper';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ConfigTypes from 'config/ConfigTypes';
import './ClipItem.scss';


const ClipItem = observer(
    class ClipItem extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                txtFs: ConfigTypes.FONTSIZE_TXT,
                headingFs: ConfigTypes.FONTSIZE_H2
            }
        }

        onClipClick = () => {
            const path = ConfigTypes.WORK_PATH;
            this.props.updateMediaObjects({ currentClip: this.props.clip, trailerPlaying: false });
            this.props.router.navigate(`${path}/${this.props.clip.id}`);
        }

        onKeyUpCard = (e) => {
            if (e.key === ConfigTypes.ENTER) {
                this.onClipClick();
            }
        }

        getContentClass = () => {
            if (isAudio()) return "custom-clipitem-content-audio";
            return "custom-clipitem-content";
        }

        getClipItemClasses = () => {
            if (isAudio()) {
                if (this.props.isOdd) return "custom-clipitem-audio-odd";
                return "custom-clipitem-audio";
            }
            return "custom-clipitem";
        }

        getClipItemCardClasses = () => {
            if (isAudio()) {
                if (!this.props.isOdd) return "custom-clipitem-card-audio-even";
                return "custom-clipitem-card-audio";
            }
            return "custom-clipitem-card";
        }


        componentDidUpdate(prev) {
            if (prev.mediaObjects.fsSettings != this.props.mediaObjects.fsSettings) {
                let fs = this.props.mediaObjects.fsSettings;
                this.setState({
                    txtFs: ConfigTypes.FONTSIZE_TXT + fs,
                    headingFs: ConfigTypes.FONTSIZE_H2 + fs
                });
            }
        }

        render() {
            return (
                <div className={this.getClipItemClasses()} onClick={this.onClipClick}>
                    <div className={this.getClipItemCardClasses()}
                        title={sliceText(this.props.clip.metadata.fields.title, ConfigTypes.TITLE_LEN)}
                        onKeyUp={this.onKeyUpCard} tabIndex="0" role="link">
                        <div className={this.getContentClass()}>
                            <MediaBox clip={this.props.clip} isthumb={true} />
                        </div>
                        {/* h2 */}
                        <h3 className="custom-clipitem-title" style={{ fontSize: `${this.state.headingFs}px` }}>
                            {sliceText(this.props.clip.metadata.fields.title, ConfigTypes.TITLE_LEN)}
                        </h3>
                        {isAudio() && (<p className="custom-clipitem-txt">
                            <pre className="custom-clipitem-pre" style={{ fontSize: `${this.state.txtFs}px` }}>
                                {sliceText(this.props.clip.metadata.fields.summary, ConfigTypes.DES_LEN)}
                            </pre></p>)}
                        {/* {!isAudio() && <div className="custom-clipitem-longtext">
                            <p>{sliceText(this.props.clip.metadata.fields.summary, ConfigTypes.DES_LEN)}</p>
                        </div>} */}
                        {isAudio() && (
                            <div className="custom-clipitem-audio-duration">
                                <span className="custom-clipitem-audio-play">
                                    <FontAwesomeIcon icon={faPlay} />
                                </span>
                                {getDuration(this.props)}
                            </div>
                        )}
                    </div>
                </div>)
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(ClipItem)));